<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="PersonalDetails" />
      <top-card current="VehicleDetails"
        :cover-type="coverType"
        :instalments="installments"
        :premiumAmount = "premiumAmount"
      >
        Kindly provide some additional details before you proceed
      </top-card>
      <v-card class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-car">Vehicle Details</card-title>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
              <v-text-field
                  id="car-make"
                  v-model="car.make"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Vehicle Make"
                  type="text"
                  disabled
                  :rules="[required('Vehicle Make')]"
              ></v-text-field>
              <v-text-field
                  id="car-model"
                  v-model="car.model"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Vehicle Model"
                  type="text"
                  :rules="[required('Vehicle Model')]"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-value"
                  v-if="coverType.covertypeId === 120"
                  v-model="car.valueOfCar"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Value of Vehicle (Kshs.)"
                  type="text"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-age"
                  v-model="car.yearOfManufacture"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Year Of Manufacture"
                  type="number"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-reg"
                  v-model="car.registrationNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Registration Number"
                  @keyup="getCapitalizedValue('registrationNumber')"
                  type="text"
                  :rules="[required('Registration Number')]"
              ></v-text-field>
              <v-text-field
                  id="car-engine"
                  v-model="car.engineNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Engine No."
                  @keyup="getCapitalizedValue('engineNumber')"
                  :rules="[required('Engine No.')]"
                  type="text"
              ></v-text-field>
              <v-text-field
                  v-model="car.logBookNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Logbook No. (optional)"
                  @keyup="getCapitalizedValue('logBookNumber')"
                  type="text"
              ></v-text-field>
              <v-text-field
                  v-model="car.cc"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Engine Size (CC)"
                  type="number"
                  :rules="[required('Engine Size (CC)')]"
              ></v-text-field>
              <v-text-field
                  v-model="car.color"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Colour"
                  @keyup="getCapitalizedValue('color')"
                  type="text"
                  :rules="[required('Color')]"
              ></v-text-field>
              <v-text-field
                  v-model="car.seatingCapacity"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Seating Capacity"
                  type="number"
                  required
                  :rules="[min('Seating Capacity',1), max('Seating Capacity', 9)]"
              ></v-text-field>
              <v-text-field
                  v-model="car.chassisNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Chassis No."
                  @keyup="getCapitalizedValue('chassisNumber')"
                  type="text"
                  :rules="[required('Chassis No.'),minLength('Chassis No.', 6)]"
              ></v-text-field>
              <v-select
                  v-model="car.variant"
                  :items= vehicleBodyType
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Body Type"
                  :rules="[required('Body Type')]">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-title
                        :id="attrs['aria-labelledby']"
                      >
                        {{ item }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
              </v-select>

            </div>

            <schedule-inspection v-if="coverType.covertypeId === 120" v-model="check" :scheduled="scheduled" :quote-id="parseInt(quote, 10)" :rules="[v => !!v || 'Inspection choice is required']" />

            <documents-upload v-if="!hideImage" v-model="documents" :all-documents="getQoute.document" registration-number="COVER" />

            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 md:tw-mt-8 tw-pb-8">
              <v-btn block large
                     id="proceed"
                     color="secondary"
                     class="my-3 "
                     :loading="loading"
                     :disabled="!isValid"
                     @click="proceed">
                {{ isValid ? 'Continue' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import TopCard from '@/components/buy/TopCard';
import ScheduleInspection from '@/components/buy/ScheduleInspection';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import validations from '@/utils/validations';
import axios from 'axios';
import { changeFormat } from '@/utils/time';
import DocumentsUpload from '@/components/buy/DocumentsUpload';
import { FB_BUY_VEHICLE } from '@/utils/const';

export default {
  name: 'VehicleDetails',
  components: {
    DocumentsUpload,
    BackNav,
    ScheduleInspection,
    TopCard,
    CardTitle,
  },
  data() {
    return {
      loading: false,
      car: {},
      benefit: '',
      quote: null,
      pageLoading: true,
      ...validations,
      isValid: false,
      check: null,
      scheduled: false,
      documents: [],
      hideImage: true,
      vehicleBodyType: [
        'Sedan',
        'Station Wagon',
        'Pick Up',
        'Suv',
        'Van',
        'Hatchback',
      ],
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    coverType() {
      return this.getQoute.covertypes.find((e) => e.riskId === this.benefit);
    },
    installments() {
      return this.getQoute.instalments;
    },
    premiumAmount() {
      return this.installments?.reduce((sum, installment) => sum + installment.premium, 0);
    },
  },
  metaInfo: {
    title: 'Buy - Vehicle Details',
  },
  mounted() {
    this.quote = this.$route.query.q;
    this.benefit = parseInt(this.$route.query.b, 10);
    this.$store.dispatch('rfq/getQuotation', this.quote).then(() => {
      this.car = this.initializeCar();
      this.car.logBookImageUrl = this.coverType.car.logBookImageUrl || '';
      if ('vehicleEvaluation' in this.getQoute) this.scheduled = true;
      this.pageLoading = false;
    });
    // eslint-disable-next-line no-unused-vars
    this.$root.$on('inspection-scheduled', (_data) => {
      this.hideImage = true;
    });
  },
  methods: {
    proceed() {
      this.loading = true;
      const data = {
        addressLine1: '1245',
        bankAccount: this.getQoute.client.bankAccount,
        bankBranch: this.getQoute.client.bankBranch,
        bankName: this.getQoute.client.bankName,
        coverFrom: this.changeFormat(this.getQoute.coverFrom),
        documents: this.documents,
        email: this.getQoute.client.email,
        fullName: this.getQoute.client.fullName,
        idNumber: this.getQoute.client.idNumber,
        kraPinNumber: this.getQoute.client.kraPinNumber,
        mobileNumber: this.getQoute.client.mobileNumber,
        pinNumber: this.getQoute.client.kraPinNumber,
        poBoxNo: this.getQoute.client.poBoxNo,
        postalCode: this.getQoute.client.postalCode,
        gender: this.getQoute.client.gender,
        carDTOS: [this.car],
        prodId: this.coverType.productCode,
        quoteId: parseInt(this.$route.query.q, 10),
        selectedRiskId: parseInt(this.benefit, 10),
        stepCode: 'CONFIRM_POLICY',
      };
      axios.put('/customer/quotation/update', data)
      // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.loading = false;
          this.$store.dispatch('rfq/getQuotation', this.quote);
          this.$toast.success('Vehicle Details successfully saved', 'Vehicle Details');
          this.$analytics.logEvent(FB_BUY_VEHICLE);
          this.$emit('to-cover-summary');
        });
    },
    initializeCar() {
      return {
        cc: this.coverType.car.cc || '',
        chassisNumber: this.coverType.car.chassisNumber || '',
        color: this.coverType.car.color || '',
        engineNumber: this.coverType.car.engineNumber || '',
        entertainmentSysValue: this.coverType.car.entertainmentSysValue || '',
        hasInsurance: this.coverType.car.hasInsurance || '',
        logBookNumber: this.coverType.car.logBookNumber || '',
        make: this.coverType.car.make || '',
        model: this.coverType.car.model || '',
        registrationNumber: this.coverType.car.registrationNumber || '',
        seatingCapacity: parseInt(this.coverType.car.seatingCapacity, 10) || null,
        valueOfCar: this.coverType.car.valueOfCar || '',
        variant: this.coverType.car.variant || '',
        windscreenValue: this.coverType.car.windscreenValue || '',
        yearOfManufacture: this.coverType.car.yearOfManufacture || '',
      };
    },
    changeFormat,
    getCapitalizedValue(key) {
      this.car[key] = this.car[key].toUpperCase();
    },
  },
};
</script>
